var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWatermark = function SvgLogoWatermark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.47,
    height: 257.72,
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    d: "M110.864 257.219a83.46 83.46 0 0 0-64.429-30.666h-.465a45.649 45.649 0 1 1 45.851-45.88v.467a83.47 83.47 0 0 0 49.591 76.08Zm50.62-36.159a45.65 45.65 0 0 1-28.287-41.988v-.479a83.485 83.485 0 0 0-83.235-83.258 3 3 0 0 1-.477 0 45.655 45.655 0 1 1 45.85-45.871v.477a83.484 83.484 0 0 0 83.246 83.243h.5a45.653 45.653 0 1 1-17.595 87.875Zm110.742-20.2a45.64 45.64 0 0 1-7.79-25.274v-.466a83.47 83.47 0 0 0-83.256-83.265h-.467a45.659 45.659 0 1 1 45.853-45.86v.44a83.47 83.47 0 0 0 61.4 80.3v88.548a45.65 45.65 0 0 1-15.739-14.427Z"
  })));
};
export default SvgLogoWatermark;